/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import { v4 as uuidV4 } from "uuid";
import Dropdown from "./dropdown";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "15px" }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "A",
      bg: true,
    },
    title: {
      value: "Tài nguyên khai thác:",
      bg: true,
    },
    DVT: {
      value: null,
      bg: true,
    },
    quantity: {
      value: null,
      bg: true,
    },
    resourceRentalPrice: {
      //gia thuế tài nguyêb
      value: null,
      bg: true,
    },
    tax: {
      // thuế sất
      value: null,
      bg: true,
    },
    resourceTaxPerUnit: {
      //mức tài nguyên ấn định trên 1 đơn vị
      value: null,
      bg: true,
    },
    compulsoryResourceTax: {
      // thuế tài nguyên phải nộp
      value: null,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      value: null,
      bg: true,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: null,
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "I",
      bg: true,
    },
    title: {
      value: "Khoáng sản:",
      bg: true,
    },
    DVT: {
      value: null,
      bg: true,
    },
    quantity: {
      value: null,
      bg: true,
    },
    resourceRentalPrice: {
      value: null,
      bg: true,
    },
    tax: {
      value: null,
      bg: true,
    },
    resourceTaxPerUnit: {
      value: null,
      bg: true,
    },
    compulsoryResourceTax: {
      value: null,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      value: null,
      bg: true,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: null,
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "1",
      bg: true,
    },
    title: {
      value: null,
      bg: false,
    },
    DVT: {
      value: null,
      bg: true,
    },
    quantity: {
      value: null,
      bg: true,
    },
    resourceRentalPrice: {
      value: null,
      bg: true,
    },
    tax: {
      value: null,
      bg: true,
    },
    resourceTaxPerUnit: {
      value: null,
      bg: true,
    },
    compulsoryResourceTax: {
      value: null,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      value: null,
      bg: true,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: null,
      bg: true,
    },
    id: {
      value: 1,
      bg: true,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "1.1",
      bg: true,
    },
    title: {
      type: "select",
      value: null,
      bg: false,
    },
    DVT: {
      type: "select",
      value: null,
      bg: false,
    },
    quantity: {
      type: "input",
      value: 0,
      bg: false,
    },
    resourceRentalPrice: {
      type: "input",
      value: 0,
      bg: false,
    },
    tax: {
      type: "input",
      value: 0,
      bg: false,
    },
    resourceTaxPerUnit: {
      type: "input",
      value: 0,
      bg: false,
    },
    compulsoryResourceTax: {
      type: "input",
      value: 0,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      value: null,
      bg: true,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: null,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      type: "input",
      value: 0,
      bg: false,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: 0,
      bg: true,
    },
    id: {
      value: uuidV4(),
      bg: true,
    },
  },

  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "A",
      bg: true,
    },
    title: {
      value: "Tài nguyên thu nộp hôm nay:",
      bg: true,
    },
    DVT: {
      value: null,
      bg: true,
    },
    quantity: {
      value: null,
      bg: true,
    },
    resourceRentalPrice: {
      value: null,
      bg: true,
    },
    tax: {
      value: null,
      bg: true,
    },
    resourceTaxPerUnit: {
      value: null,
      bg: true,
    },
    compulsoryResourceTax: {
      value: null,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      value: null,
      bg: true,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: null,
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
  },

  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "1",
      bg: true,
    },
    title: {
      type: "select",
      value: null,
      bg: false,
    },
    DVT: {
      type: "select",
      value: null,
      bg: false,
    },
    quantity: {
      type: "input",
      value: 0,
      bg: false,
    },
    resourceRentalPrice: {
      type: "input",
      value: 0,
      bg: false,
    },
    tax: {
      type: "input",
      value: 0,
      bg: false,
    },
    resourceTaxPerUnit: {
      type: "input",
      value: 0,
      bg: false,
    },
    compulsoryResourceTax: {
      type: "input",
      value: 0,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      value: null,
      bg: true,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: null,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      type: "input",
      value: 0,
      bg: false,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: 0,
      bg: true,
    },
    id: {
      value: 3,
      bg: true,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "A",
      bg: true,
    },
    title: {
      value: "Tài nguyên bắt giữ, tịch thu:",
      bg: true,
    },
    DVT: {
      value: null,
      bg: true,
    },
    quantity: {
      value: null,
      bg: true,
    },
    resourceRentalPrice: {
      value: null,
      bg: true,
    },
    tax: {
      value: null,
      bg: true,
    },
    resourceTaxPerUnit: {
      value: null,
      bg: true,
    },
    compulsoryResourceTax: {
      value: null,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      value: null,
      bg: true,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: null,
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
  },

  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "1",
      bg: true,
    },
    title: {
      type: "select",
      value: null,
      bg: false,
    },
    DVT: {
      type: "select",
      value: null,
      bg: false,
    },
    quantity: {
      type: "input",
      value: 0,
      bg: false,
    },
    resourceRentalPrice: {
      type: "input",
      value: 0,
      bg: false,
    },
    tax: {
      type: "input",
      value: 0,
      bg: false,
    },
    resourceTaxPerUnit: {
      type: "input",
      value: 0,
      bg: false,
    },
    compulsoryResourceTax: {
      type: "input",
      value: 0,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      type: "input",
      value: 0,
      bg: false,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: 0,
      bg: true,
    },
    id: {
      value: 3,
      bg: true,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "",
      bg: true,
    },
    title: {
      value: "Tổng cộng:",
      bg: true,
    },
    DVT: {
      value: null,
      bg: true,
    },
    quantity: {
      value: 0,
      bg: true,
    },
    resourceRentalPrice: {
      value: null,
      bg: true,
    },
    tax: {
      value: null,
      bg: true,
    },
    resourceTaxPerUnit: {
      value: null,
      bg: true,
    },
    compulsoryResourceTax: {
      value: 0,
      bg: true,
    },
    declaredTax: {
      // thuế đã kê khai trong năm
      value: 0,
      bg: true,
    },
    quantityDifference: {
      // chênh lệch giữa số quyết toán và số đã kê khai
      value: 0,
      bg: true,
    },
    id: {
      value: 0,
      bg: true,
    },
  },
];
const resourceOption = [
  {
    value: "sắt",
    label: "Sắt",
  },
  {
    value: "sắt kim loại",
    label: "Sắt kim loại",
  },
  {
    value: "quặng Manhetit (có từ tính)",
    label: "Quặng Manhetit (có từ tính)",
  },
  {
    value: "quặng Limonit (không từ tính)",
    label: "Quặng Limonit (không từ tính)",
  },
];
const DVTOption = [
  {
    value: "kg",
    label: "Kg",
  },
  {
    value: "tấn",
    label: "Tấn",
  },
  {
    value: "thùng",
    label: "Thùng",
  },
  {
    value: "kwh",
    label: "KWh",
  },
  {
    value: "m3",
    label: "M3",
  },
  {
    value: "lít",
    label: "Lít",
  },
  {
    value: "cây",
    label: "Cây",
  },
];

const content = {
  item1: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: "1.1",
        bg: true,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceRentalPrice: {
        type: "input",
        value: 0,
        bg: false,
      },
      tax: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceTaxPerUnit: {
        type: "input",
        value: 0,
        bg: false,
      },
      compulsoryResourceTax: {
        type: "input",
        value: 0,
        bg: true,
      },
      declaredTax: {
        // thuế đã kê khai trong năm
        value: null,
        bg: true,
      },
      quantityDifference: {
        // chênh lệch giữa số quyết toán và số đã kê khai
        value: null,
        bg: true,
      },
      declaredTax: {
        // thuế đã kê khai trong năm
        type: "input",
        value: 0,
        bg: false,
      },
      quantityDifference: {
        // chênh lệch giữa số quyết toán và số đã kê khai
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
  item2: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: "1.1",
        bg: true,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceRentalPrice: {
        type: "input",
        value: 0,
        bg: false,
      },
      tax: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceTaxPerUnit: {
        type: "input",
        value: 0,
        bg: false,
      },
      compulsoryResourceTax: {
        type: "input",
        value: 0,
        bg: true,
      },
      declaredTax: {
        // thuế đã kê khai trong năm
        value: null,
        bg: true,
      },
      quantityDifference: {
        // chênh lệch giữa số quyết toán và số đã kê khai
        value: null,
        bg: true,
      },
      declaredTax: {
        // thuế đã kê khai trong năm
        type: "input",
        value: 0,
        bg: false,
      },
      quantityDifference: {
        // chênh lệch giữa số quyết toán và số đã kê khai
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
  item3: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: "1.1",
        bg: true,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceRentalPrice: {
        type: "input",
        value: 0,
        bg: false,
      },
      tax: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceTaxPerUnit: {
        type: "input",
        value: 0,
        bg: false,
      },
      compulsoryResourceTax: {
        type: "input",
        value: 0,
        bg: true,
      },
      declaredTax: {
        // thuế đã kê khai trong năm
        value: null,
        bg: true,
      },
      quantityDifference: {
        // chênh lệch giữa số quyết toán và số đã kê khai
        value: null,
        bg: true,
      },
      declaredTax: {
        // thuế đã kê khai trong năm
        type: "input",
        value: 0,
        bg: false,
      },
      quantityDifference: {
        // chênh lệch giữa số quyết toán và số đã kê khai
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
};

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(content);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        console.log(item);
        if (item.id.value === id) {
          return { ...item, [name]: { type: item[name]?.type, value } };
        }
        return item;
      }),
    }));
  };

  const addNewRow = (item) => {
    const newIdValue = data[item].length + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      index: {
        value: "1.1",
        bg: true,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceRentalPrice: {
        type: "input",
        value: 0,
        bg: false,
      },
      tax: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceTaxPerUnit: {
        type: "input",
        value: 0,
        bg: false,
      },
      compulsoryResourceTax: {
        type: "input",
        value: 0,
        bg: true,
      },
      declaredTax: {
        // thuế đã kê khai trong năm
        value: null,
        bg: true,
      },
      quantityDifference: {
        // chênh lệch giữa số quyết toán và số đã kê khai
        value: null,
        bg: true,
      },
      declaredTax: {
        // thuế đã kê khai trong năm
        type: "input",
        value: 0,
        bg: false,
      },
      quantityDifference: {
        // chênh lệch giữa số quyết toán và số đã kê khai
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    };

    setData((prev) => ({ ...prev, [item]: [...prev[item], newRow] }));
  };

  const handleDelete = (type, index) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type].filter((item) => item.id.value !== index),
    }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center", width: "15%" }} rowSpan="2">
                Tên loại tài nguyên
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Sản lượng tài nguyên tính thuế
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Giá tính thuê đơn vị tài nguyên
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế suất (%)
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Mức thuế tài nguyên ấn định trên 1 đơn vị tài nguyên
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế tài nguyên phải nộp
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế tài nguyên đã kê khai trong năm
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Chênh lệch giữa số quyết toán với đã kê khai
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", width: "7%" }}>ĐVT</Th>
              <Th style={{ textAlign: "center" }}>Sản lượng</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8) = (4)x(5)(6) hoặc (8)=(4)x(7)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10) = (8)-(9)</Th>
            </tr>

            <tr>
              <Th
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                A
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item1")}>
                    Thêm dòng
                  </button>
                </div>
              </Th>
              <Th
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tài nguyên khai thác
              </Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
            </tr>

            <tr>
              <Th
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                I
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item1")}>
                    Thêm dòng
                  </button>
                </div>
              </Th>
              <Th
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Khoáng sản
              </Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
            </tr>

            <tr>
              <Th
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                1
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item1")}>
                    Thêm dòng
                  </button>
                </div>
              </Th>
              <Th
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "   none",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.item1.length > 0 &&
              data.item1.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index < 1 ? 1 + 0.1 : index === 1 ? 1 + 0.2 : 1 + 0.1 * (index + 1)}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item1", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType={"item1"}
                        name="resource"
                        id={row.id.value}
                        option={resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType={"item1"}
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        id={row.id.value}
                        type={"number"}
                        name="quantity"
                        value={row.quantity.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.resourceRentalPrice?.type !== "input" ? (
                      row.resourceRentalPrice.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        id={row.id.value}
                        type={"number"}
                        name="resourceRentalPrice"
                        value={row.resourceRentalPrice.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        id={row.id.value}
                        type={"number"}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.resourceTaxPerUnit.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.resourceTaxPerUnit?.type !== "input" ? (
                      row.resourceTaxPerUnit.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        id={row.id.value}
                        type={"number"}
                        name="resourceTaxPerUnit"
                        value={row.resourceTaxPerUnit.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.compulsoryResourceTax.value}
                  </Td>

                  {!row.onlyTitle && (
                    <>
                      <Td
                        row={row}
                        style={{
                          textAlign: "center",
                          background: !row.id.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.id.value}
                      </Td>
                      <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row.arisingNumber.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.arisingNumber.bg ? (
                          row.arisingNumber.value
                        ) : (
                          <InputTable
                            rowType={"item1"}
                            id={row.id.value}
                            name="arisingNumber"
                            value={row.arisingNumber.value}
                            onChange={handleChange}
                          />
                        )}
                      </Td>
                    </>
                  )}

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.declaredTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.declaredTax?.type !== "input" ? (
                      row.declaredTax.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        id={row.id.value}
                        type={"number"}
                        name="declaredTax"
                        value={row.declaredTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantityDifference.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantityDifference?.type !== "input" ? (
                      row.quantityDifference.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        id={row.id.value}
                        type={"number"}
                        name="quantityDifference"
                        value={row.quantityDifference.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Th
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                II
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item2")}>
                    Thêm dòng
                  </button>
                </div>
              </Th>
              <Th
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tài nguyên khác
              </Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
            </tr>

            {data &&
              data.item2.length > 0 &&
              data.item2.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item2", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType={"item2"}
                        name="resource"
                        id={row.id.value}
                        option={resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType={"item2"}
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="quantity"
                        value={row.quantity.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.resourceRentalPrice?.type !== "input" ? (
                      row.resourceRentalPrice.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="resourceRentalPrice"
                        value={row.resourceRentalPrice.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.resourceTaxPerUnit.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.resourceTaxPerUnit?.type !== "input" ? (
                      row.resourceTaxPerUnit.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="resourceTaxPerUnit"
                        value={row.resourceTaxPerUnit.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.compulsoryResourceTax.value}
                  </Td>

                  {!row.onlyTitle && (
                    <>
                      <Td
                        row={row}
                        style={{
                          textAlign: "center",
                          background: !row.id.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.id.value}
                      </Td>
                      <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row.arisingNumber.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.arisingNumber.bg ? (
                          row.arisingNumber.value
                        ) : (
                          <InputTable
                            rowType={"item2"}
                            id={row.id.value}
                            name="arisingNumber"
                            value={row.arisingNumber.value}
                            onChange={handleChange}
                          />
                        )}
                      </Td>
                    </>
                  )}

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.declaredTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.declaredTax?.type !== "input" ? (
                      row.declaredTax.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="declaredTax"
                        value={row.declaredTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantityDifference.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantityDifference?.type !== "input" ? (
                      row.quantityDifference.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="quantityDifference"
                        value={row.quantityDifference.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Th
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                B
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item3")}>
                    Thêm dòng
                  </button>
                </div>
              </Th>
              <Th
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tài nguyên thu mua nộp thay
              </Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
            </tr>

            {data &&
              data.item3.length > 0 &&
              data.item3.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item3", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType={"item2"}
                        name="resource"
                        id={row.id.value}
                        option={resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType={"item2"}
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="quantity"
                        value={row.quantity.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.resourceRentalPrice?.type !== "input" ? (
                      row.resourceRentalPrice.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="resourceRentalPrice"
                        value={row.resourceRentalPrice.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.resourceTaxPerUnit.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.resourceTaxPerUnit?.type !== "input" ? (
                      row.resourceTaxPerUnit.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="resourceTaxPerUnit"
                        value={row.resourceTaxPerUnit.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.compulsoryResourceTax.value}
                  </Td>

                  {!row.onlyTitle && (
                    <>
                      <Td
                        row={row}
                        style={{
                          textAlign: "center",
                          background: !row.id.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.id.value}
                      </Td>
                      <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row.arisingNumber.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.arisingNumber.bg ? (
                          row.arisingNumber.value
                        ) : (
                          <InputTable
                            rowType={"item2"}
                            id={row.id.value}
                            name="arisingNumber"
                            value={row.arisingNumber.value}
                            onChange={handleChange}
                          />
                        )}
                      </Td>
                    </>
                  )}

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.declaredTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.declaredTax?.type !== "input" ? (
                      row.declaredTax.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="declaredTax"
                        value={row.declaredTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantityDifference.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantityDifference?.type !== "input" ? (
                      row.quantityDifference.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        type={"number"}
                        name="quantityDifference"
                        value={row.quantityDifference.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Th
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng
              </Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Th>
              <Th
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Th>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    console.log(type);
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type, rowType });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name, type, rowType });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
